// extracted by mini-css-extract-plugin
module.exports = {"lazyLoader":"Se-z"};